import * as React from 'react';

import { KEEP_OFFER_PREVIEW_OPEN_ATTR } from '../../../../../constants/offerPreview';
import { isUserDrivenAction } from '../../../../../utils/ymaps/isUserDrivenAction';

interface IUseBalloonAutoCloseParams {
  rootElement: HTMLElement | null;
  map: YMaps.Map;
  onClose(): void;
}

export function useBalloonAutoClose({ rootElement, map, onClose }: IUseBalloonAutoCloseParams) {
  React.useEffect(() => {
    if (!rootElement) {
      return;
    }

    const mapElement = map.container.getParentElement();
    let hasClosed = false;

    const close = () => {
      if (hasClosed) {
        return;
      }

      hasClosed = true;
      onClose();
    };

    const handleDocumentClick = (event: MouseEvent) => {
      const target = event.target as Element | null;

      if (rootElement.contains(target)) {
        return;
      }

      // DOM-клик по пину попадает в общий слой событий карты.
      // Выбор пина и закрытие по пустой карте обрабатывают события YMaps.
      if (mapElement.contains(target)) {
        return;
      }

      if (target?.closest(`[${KEEP_OFFER_PREVIEW_OPEN_ATTR}]`)) {
        return;
      }

      close();
    };

    const handleMapWheel = (event: WheelEvent) => {
      const target = event.target as Element | null;

      if (rootElement.contains(target)) {
        return;
      }

      close();
    };

    const closeOnUserMapAction = (event: YMaps.IEvent) => {
      if (!isUserDrivenAction(event.get<unknown>('action'))) {
        return;
      }

      close();
    };

    document.addEventListener('click', handleDocumentClick, true);
    mapElement.addEventListener('wheel', handleMapWheel, true);
    map.events.add('actionend', closeOnUserMapAction);

    return () => {
      document.removeEventListener('click', handleDocumentClick, true);
      mapElement.removeEventListener('wheel', handleMapWheel, true);
      map.events.remove('actionend', closeOnUserMapAction);
    };
  }, [rootElement, map, onClose]);
}
